import axios from 'axios'

class AuthApi {
    constructor(apiToken) {
        this.apiToken = apiToken.startsWith('Bearer ')
            ? apiToken
            : `Bearer ${apiToken}`
        this.client = axios.create({
            baseURL: '/api/auth',
            timeout: 10000,
            headers: { Authorization: this.apiToken },
        })
        this.responses = {}
    }

    /**
     * Some request need to pass an updated token. For instance on impersonated calls, an
     * extra piece is attached to the api token.
     * @param newToken
     */
    updateToken(newToken) {
        this.client.defaults.headers.Authorization = newToken
    }

    fetchTenants(username) {
        if (this.responses.tenants) {
            return this.responses.tenants
        }
        this.responses.tenants = this.client.get(`/users/${username}/tenants`)
        return this.responses.tenants
    }

    fetchAppPermissions(username, organization) {
        let params = {}
        if (organization) {
            params.organization_id = organization
        }
        return this.client.get(`/users/${username}/app-permissions`, {
            params,
        })
    }

    deleteImpersonator() {
        return this.client.delete('/impersonator', {
            params: {
                organization_only: true,
            },
        })
    }

    postImpersonator(selectedOrg) {
        return this.client.post('/impersonator', {
            organization_id: selectedOrg,
        })
    }
}

export { AuthApi }
